/**
 * Test if a route is a valid project page
 * @param route
 * @returns
 */
export function isValidProjectRoute(route?: string): boolean {
  if(!route) return false;
  return (
    route.toLowerCase() === "reports" ||
    route.toLowerCase() === "lists" ||
    route.toLowerCase() === "details"
  );
}
